import en from './en.json'
import ru from './ru.json'

export const config = {
  locale: 'ru',
  fallbackLocale: 'en',
  messages: {
    en: en,
    ru: ru,
  }
}